import { useEffect, useState } from 'react'

import { TaskStatus } from 'core/application/adminDashboard/adminTasks'
import benefitPlanPeriods, { PlanPeriodDto } from 'core/application/adminDashboard/benefitDetails/benefitPlanPeriods'
import updateCompanyForIntroView from 'core/application/adminDashboard/sendUpdateCompanyForIntroView'
import isOpenEnrollmentPeriod from 'core/application/benefit/benefitRenewal/qsehra/IsOpenEnrollmentPeriod'
import { sessionStore } from 'core/application/commons/localStorage'
import { BenefitDesignStatus } from 'core/domain/benefit/benefitDesignStatus'

import useAdminTasks from 'common/hooks/useAdminTasks'

import { BenefitPlanPeriodDropDown, Col, Row } from 'common/components'
import ExplanationModal from 'common/explenationModal'
import { useCommandRequestV2, useLoginUserV2, useQueryParams, useQueryRequestV2 } from 'common/hooks'

import AllowanceSpent from '../common/allowanceSpent'
import Engagement from '../common/engagement'
import InitialPremiumStatuses from '../common/initialPremiumStatuses'
import OnboardingStatuses from '../common/onboardingStatuses'
import WelcomeBox from '../common/welcomeBox'
import AdminCountdownTimer from '../ichra/adminCountdownTimer'
import AdminTasks from './adminTasks'

const IchraAdminDashboardHome = () => {
  const queryParams = useQueryParams()
  const planPeriodIdQueryParam = queryParams.get('planPeriodId')
  const [showExplanationModal, setShowExplanationModal] = useState(true)

  const [tasks] = useAdminTasks()
  const { user } = useLoginUserV2()
  const tasksCompleted = tasks && !tasks.some((x) => x.status != TaskStatus.Done)
  const [selectedPlanPeriod, setSelectedPlanPeriod] = useState<PlanPeriodDto | null>()
  const { data: planPeriods } = useQueryRequestV2<PlanPeriodDto[]>({
    initialState: null,
    queryFn: () => benefitPlanPeriods(),
  })

  const { sendCommand: sendUpdateIntroductionModal } = useCommandRequestV2(({}) =>
    updateCompanyForIntroView(user.companyUserId),
  )
  const { data: isOpenEnrollment } = useQueryRequestV2({ initialState: false, queryFn: () => isOpenEnrollmentPeriod() })

  const handleCloseExplanationModal = async () => {
    await sendUpdateIntroductionModal({})
    setShowExplanationModal(false)
  }

  useEffect(() => {
    if (planPeriods && planPeriods.length > 0) {
      const found = planPeriodIdQueryParam
        ? planPeriods.find((x) => x.id === planPeriodIdQueryParam)
        : planPeriods.find((x) => x.active == true)

      if (found) {
        setSelectedPlanPeriod(found)
      }
    }
  }, [planPeriods])

  return (
    <>
      <Row justify="end" className={'w-100 font-16 text-light-bold mb-16'}>
        {planPeriods && planPeriods.length > 1 && (
          <BenefitPlanPeriodDropDown
            planPeriods={planPeriods}
            onPlanPeriodSelected={(planPeriodId: string) => {
              const found = planPeriods.find((x) => x.id === planPeriodId)
              setSelectedPlanPeriod(found)
            }}
          />
        )}
      </Row>
      {tasks && selectedPlanPeriod && (
        <>
          {!tasksCompleted && <AdminTasks activePlanPeriod={selectedPlanPeriod} />}

          {tasksCompleted && (
            <>
              {isOpenEnrollment && selectedPlanPeriod.benefitDesignStatus == BenefitDesignStatus.Signed && (
                <Row className={'mb-16'}>
                  <Col span={24}>
                    <AdminCountdownTimer planPeriod={selectedPlanPeriod} user={user} />
                  </Col>
                </Row>
              )}

              <Row className={'mb-16'}>
                <Col span={24}>
                  <WelcomeBox planPeriodId={selectedPlanPeriod.id} />
                </Col>
              </Row>

              <Row gutter={16}>
                <Col xs={24} md={12} className="mb-16">
                  <AllowanceSpent planPeriod={selectedPlanPeriod} />
                </Col>

                <Col xs={24} sm={12} className="mb-16">
                  {selectedPlanPeriod.active && <Engagement planPeriod={selectedPlanPeriod} />}
                </Col>

                {/* <Col xs={24} md={12} lg={15} xl={15}>
                  {<TotalSpendByCategory planPeriod={selectedPlanPeriod} />}
                </Col> */}
              </Row>
              <Row className={'mb-16'}>
                <OnboardingStatuses planPeriod={selectedPlanPeriod} />
              </Row>
              <InitialPremiumStatuses planPeriod={selectedPlanPeriod} />
            </>
          )}
        </>
      )}
      {user.displayIntro && showExplanationModal && !sessionStore.getSessionToken() && (
        <ExplanationModal
          title="Welcome to your new dashboard!"
          description="We’ve upgraded your account to our newest version of ICHRA. We hope you like it! If you need help with your new dashboard features or have any questions, please contact us using the Support link in the bottom-right corner of your page. We’ll be happy to assist you!"
          onCancel={handleCloseExplanationModal}
          name={user.firstName}
          hideVideo
        />
      )}
    </>
  )
}

export default IchraAdminDashboardHome
